import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { formatNumber } from '../../../utils/index';
import { connect, useDispatch } from 'react-redux';
import TrackEventLink from '../../../components/track-event-link/TrackEventLink';
import RoundedImage from '../../../components/RoundedImage';
import VisibilitySensor from '../../../components/visibility-sensor/VisibilitySensor';
import styles from './project-card.module.less';
import { fetchProjectCard, fetchProjectTransactionAggregates } from '../../../project/project-actions';
import { getProjectFromId } from '../../../project/projects-reducer';
import LoaderProjectCard from '../../../project/project-flat-card/LoaderProjectCard';

const ProjectFlatCard = ({ project, link, projectId, collectedAmountFirst24Hours, category, action, properties }) => {
    const dispatch = useDispatch();
    const handleVisible = useCallback(() => {
        dispatch(fetchProjectCard(projectId));
        dispatch(fetchProjectTransactionAggregates(projectId));
    }, [dispatch, projectId]);

    if (!project || project?.id !== projectId) {
        return (
            <VisibilitySensor onVisible={handleVisible} offset={{ bottom: 500 }}>
                <LoaderProjectCard />
            </VisibilitySensor>
        );
    }

    return (
        <TrackEventLink
            category={category}
            action={action}
            properties={properties}
            to={link || `/project/${projectId}`}
            className={[styles.linkBlock, styles.container].join(' ')}
        >
            <div className={styles.contentWrapper}>
                <div className={styles.primaryWrapper}>
                    <RoundedImage className={styles.fullImage} src={project.img_url} />
                </div>
                <div className={styles.secondaryWrapper}>
                    <div className={styles.titleContainer}>
                        <div className={styles.title}>{project?.title}</div>
                    </div>
                    <div className={styles.moneyInfo}>
                        <div className={styles.collectedInfo}>
                            {formatNumber(collectedAmountFirst24Hours || project?.collected_amount)} kr innsamlet
                        </div>
                    </div>
                </div>
            </div>
        </TrackEventLink>
    );
};

ProjectFlatCard.propTypes = {
    projectId: PropTypes.number.isRequired,
    project: PropTypes.object,
    category: PropTypes.string,
    action: PropTypes.string,
    parameters: PropTypes.object,
    link: PropTypes.string,
};

function mapStateToProps(state, props) {
    let projectId = parseInt(props.projectId, 10);
    let project = props.project;
    if (projectId) {
        project = getProjectFromId(state, projectId);
    } else if (project) {
        projectId = project.id;
    }

    if (!!state.transactions?.push && state.transactions.transactions?.[0]?.collected) {
        const latestTransaction = state.transactions.transactions[0];
        if (project && projectId === latestTransaction.project_id) {
            project.collected_amount = latestTransaction.collected;
        }
    }

    return {
        project,
        projectId,
    };
}

export default connect(mapStateToProps)(ProjectFlatCard);
